/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Page_Book_LeadInputs */

const en_how_page_book_lead = /** @type {(inputs: How_Page_Book_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A day, a time, done.`)
};

const pl_how_page_book_lead = /** @type {(inputs: How_Page_Book_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dzień, godzina, gotowe.`)
};

/**
* | output |
* | --- |
* | "A day, a time, done." |
*
* @param {How_Page_Book_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const how_page_book_lead = /** @type {((inputs?: How_Page_Book_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Page_Book_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_how_page_book_lead(inputs)
	return en_how_page_book_lead(inputs)
});